// Carrousel des témoignages : enrichit la piste scrollable avec des boutons
// précédent / suivant. Injectés en JS => absents (et donc pas d'UI cassée)
// si le JS est désactivé, la piste reste utilisable au scroll natif.
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    var section = document.querySelector(".testimonials");
    if (!section) return;
    var track = section.querySelector(".testimonials__track");
    if (!track) return;
    if (track.querySelectorAll(".testimonial").length < 2) return;

    var controls = document.createElement("div");
    controls.className = "testimonials__controls";

    var prev = document.createElement("button");
    prev.type = "button";
    prev.className = "testimonials__nav testimonials__nav--prev";
    prev.setAttribute("aria-label", "Témoignage précédent");
    prev.innerHTML = "‹";

    var next = document.createElement("button");
    next.type = "button";
    next.className = "testimonials__nav testimonials__nav--next";
    next.setAttribute("aria-label", "Témoignage suivant");
    next.innerHTML = "›";

    controls.appendChild(prev);
    controls.appendChild(next);
    track.insertAdjacentElement("afterend", controls);

    function step() {
      var slide = track.querySelector(".testimonial");
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    prev.addEventListener("click", function () {
      track.scrollBy({ left: -step(), behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      track.scrollBy({ left: step(), behavior: "smooth" });
    });
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });
})();
